import clsx from 'clsx';
import DataConsistency from 'pages/DataManagementDataQuality/components/DataConsistency';
import DataIntermittenceTable from 'pages/DataManagementDataQuality/components/DataIntermittenceTable';
import LastTimestamp from 'pages/DataManagementDataQuality/components/LastTimestamp';
import MnemonicMappingTable from 'pages/DataManagementDataQuality/components/MnemonicMappingTable';
import Outlier from 'pages/DataManagementDataQuality/components/Outlier';
import { useIntl } from 'react-intl';
import { DataConsistencyDTO } from 'types/dataConsistency';
import { WellboreDataIntermittenceDTO } from 'types/dataIntermittenceDto';
import { MnemonicsMappingAndLiveStatusDTO } from 'types/mnemonicsMapping';
import { WellboreOutlierDTO } from 'types/outlierDto';

import styles from './DetailedWellboreDataQuality.module.scss';

export interface Props {
  locationType?: string;
  isFlowInBstNA: boolean;
  isFlowOutAVNA?: boolean;
  isFlowOutPCNA?: boolean;
  outlier?: WellboreOutlierDTO;
  dataConsistency?: DataConsistencyDTO;
  dataIntermittence?: WellboreDataIntermittenceDTO;
  mnemonicsMapping?: MnemonicsMappingAndLiveStatusDTO;
}

const DetailedWellboreDataQuality = ({
  outlier,
  locationType,
  isFlowInBstNA,
  isFlowOutAVNA,
  isFlowOutPCNA,
  dataConsistency,
  mnemonicsMapping,
  dataIntermittence,
}: Props) => {
  const intl = useIntl();

  return (
    <table className={styles.table}>
      <tbody>
        <tr className={styles.tableRow}>
          <td className={clsx(styles.tableCell, styles.tableCellWithBorder)}>
            <h2 className={styles.tableCellHeader}>
              {intl.formatMessage({ id: 'detailedWellboreDataQuality.criticalMnemonicsMapping' })}
            </h2>
            <MnemonicMappingTable
              liveMnemonics={mnemonicsMapping?.liveData}
              mnemonicsDepthData={mnemonicsMapping?.depthData}
              isFlowOutAVNA={isFlowOutAVNA}
              isFlowOutPCNA={isFlowOutPCNA}
              isFlowInBstNA={isFlowInBstNA}
              isLive={true}
            />
          </td>
          <td className={clsx(styles.tableCell, styles.tableCellWithBorder)}>
            <h2 className={styles.tableCellHeader}>
              {intl.formatMessage({ id: 'detailedWellboreDataQuality.lastTimeReceived' })}
            </h2>
            <LastTimestamp
              mnemonicsMapping={mnemonicsMapping}
              isFlowoutAVNA={isFlowOutAVNA}
              isFlowoutPCNA={isFlowOutPCNA}
              isFlowInBstNA={isFlowInBstNA}
            />
          </td>
          <td className={clsx(styles.tableCell, styles.tableCellWithBorder)}>
            <h2 className={styles.tableCellHeader}>
              {intl.formatMessage({ id: 'detailedWellboreDataQuality.outliersOccurence' })}
            </h2>
            <Outlier outlier={outlier} />
          </td>
          <td className={styles.tableCell}>
            <h2 className={styles.tableCellHeader}>
              {intl.formatMessage({ id: 'detailedWellboreDataQuality.dataIntermittence' })}
            </h2>
            <DataIntermittenceTable dataIntermittence={dataIntermittence} />
          </td>
          <td className={clsx(styles.tableCell, styles.cellDataConsistency)}>
            <h2 className={styles.tableCellHeader}>
              {intl.formatMessage({ id: 'detailedWellboreDataQuality.dataConsistencyCheck' })}
            </h2>
            <DataConsistency
              dataConsistency={dataConsistency}
              locationType={locationType}
              isFlowinBstNa={isFlowInBstNA}
              mnemonicsMapping={mnemonicsMapping}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default DetailedWellboreDataQuality;
